// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/Images/border.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/Images/border.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/Images/join_button_header.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
    font-family: PP-NueBit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

header{
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    font-family: PP-NueBit;
    font-size: 25px;
    padding: 15px;
    /* margin-left: 4vw;
    margin-right: 4vw; */
    background-color: #EDEDED;
    align-items: center;
    /* top:0;
    position: fixed;
    z-index: 10; */
}

.title{
    /* margin: 10px; */
    margin-left: 2vw;
    padding: 10px;
    font-size: 42px;
    text-decoration: none;
    color: black;
}

.ambassadors{
    margin: 10px;
    padding: 11px;
    font-family: 'PP-NueBit';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 23px;
    border-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 0 0 5 0;
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
        border-bottom:8px;
}

.header-right{
    display: flex;
    flex-direction: row;
    width: 400px;
    justify-content: space-around;
    margin-right: 4vw;
    align-items: center;
}

.header-right .abcd{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.header-right .border{
    width: 78%;
    /* background-color: black; */
    height: 8px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
}

.join-button{
    /* margin: 10px;
    padding: 14px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 145px;
    height: 28px;
    text-align: left;
    background-image: url("../../assets/Images/join_button_header.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    cursor: pointer; */
}

.join-button:hover{
    transform: scale(1.1);
}

.join-p{
    color: white;
    font-weight: 100;
    font-size: 25px;
    /* margin: 10px; */
    padding: 14px;
    padding-top:20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 145px;
    height: 28px;
    text-align: left;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
        background-repeat: no-repeat;
        background-size: 100% 100%;
    cursor: pointer;
}   

.nav-item{
    list-style: none;
    text-decoration: none;
    font-family: PP-NueBit;
    font-size: 54px;
    line-height: 39px;
    letter-spacing: 0em;
}

.wxyz{
    padding-top: 16px;
    padding-bottom: 4px;
}

a{
   
    text-decoration: none;
    color: black;
}

.nav-menu.active{
    position: absolute;
    left: 13px;
    
}

.nav-menu.active + body{
    overflow-y: hidden;
}

.nav-menu{
    display: flex;
    justify-content: center;
    flex-direction: column; 
    gap: 10px;
    padding: 0;
    text-align: left;
    position: absolute;
    transition: 0.7s ease-in-out;
    left: -110vw;
    top:25px;
    background: #EDEDED;
    width: 100%;
    height: 95vh;
}

.bar{
    display: block;
    width: 25px;
    height: 3px;
    margin: 5px 0;
    background: black;
}

.ham-menu{
    display: none;
}

.hamburger{
    margin-right: 20px;
    transition: 0.7s ease-in-out;
}

.hamburger.active .bar:nth-child(2){
    opacity: 0;
}

.hamburger.active .bar:nth-child(1){
    transform: translatey(8px) rotate(45deg);
    transition: 0.7s ease-in-out;
}
.hamburger.active .bar:nth-child(3){
    transform: translatey(-8px) rotate(-45deg);
    transition: 0.7s ease-in-out;
}



@media only screen and (max-width: 600px){
    header{
        margin: 0;
        padding: 5px;  
        position: sticky;
        top: 0;
        background-color: #EDEDED;
        z-index: 2;
        width: 100%;
        align-items: center;
    }
    .title{
        padding: 0;
        margin: 8px;
    }

    .header-right{
        display: none;
    }

    .ham-menu{
        display: block;
    }
    .nav-item{
        list-style: none;
        text-decoration: none;
        font-family: PP-NueBit;
        font-size: 54px;
        line-height: 39px;
        letter-spacing: 0em;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,4CAA8C;AAClD;;AAEA;IACI,sBAAsB;IACtB,4CAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb;wBACoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB;;kBAEc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6DAA2D;QACvD,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,WAAW;IACX,yDAAuD;IACvD,4BAA4B;AAChC;;AAEA;IACI;;;;;;;;;;;sBAWkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yDAAmE;QAC/D,4BAA4B;QAC5B,0BAA0B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAElB,4BAA4B;IAC5B,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,4BAA4B;AAChC;AACA;IACI,0CAA0C;IAC1C,4BAA4B;AAChC;;;;AAIA;IACI;QACI,SAAS;QACT,YAAY;QACZ,gBAAgB;QAChB,MAAM;QACN,yBAAyB;QACzB,UAAU;QACV,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,qBAAqB;QACrB,sBAAsB;QACtB,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ","sourcesContent":["@font-face {\n    font-family: N27;\n    src: url(\"../../assets/Fonts/N27-Regular.otf\");\n}\n\n@font-face {\n    font-family: PP-NueBit;\n    src: url(\"../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n\nheader{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n    font-family: PP-NueBit;\n    font-size: 25px;\n    padding: 15px;\n    /* margin-left: 4vw;\n    margin-right: 4vw; */\n    background-color: #EDEDED;\n    align-items: center;\n    /* top:0;\n    position: fixed;\n    z-index: 10; */\n}\n\n.title{\n    /* margin: 10px; */\n    margin-left: 2vw;\n    padding: 10px;\n    font-size: 42px;\n    text-decoration: none;\n    color: black;\n}\n\n.ambassadors{\n    margin: 10px;\n    padding: 11px;\n    font-family: 'PP-NueBit';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 23px;\n    border-image: url(\"../../assets/Images/border.png\") 0 0 5 0;\n        border-top: 0px;\n        border-left: 0px;\n        border-right: 0px;\n        border-bottom:8px;\n}\n\n.header-right{\n    display: flex;\n    flex-direction: row;\n    width: 400px;\n    justify-content: space-around;\n    margin-right: 4vw;\n    align-items: center;\n}\n\n.header-right .abcd{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.header-right .border{\n    width: 78%;\n    /* background-color: black; */\n    height: 8px;\n    background-image: url(\"../../assets/Images/border.svg\");\n    background-repeat: no-repeat;\n}\n\n.join-button{\n    /* margin: 10px;\n    padding: 14px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    width: 145px;\n    height: 28px;\n    text-align: left;\n    background-image: url(\"../../assets/Images/join_button_header.png\");\n        background-repeat: no-repeat;\n        background-size: 100% 100%;\n    cursor: pointer; */\n}\n\n.join-button:hover{\n    transform: scale(1.1);\n}\n\n.join-p{\n    color: white;\n    font-weight: 100;\n    font-size: 25px;\n    /* margin: 10px; */\n    padding: 14px;\n    padding-top:20px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    width: 145px;\n    height: 28px;\n    text-align: left;\n    align-items: center;\n    background-image: url(\"../../assets/Images/join_button_header.png\");\n        background-repeat: no-repeat;\n        background-size: 100% 100%;\n    cursor: pointer;\n}   \n\n.nav-item{\n    list-style: none;\n    text-decoration: none;\n    font-family: PP-NueBit;\n    font-size: 54px;\n    line-height: 39px;\n    letter-spacing: 0em;\n}\n\n.wxyz{\n    padding-top: 16px;\n    padding-bottom: 4px;\n}\n\na{\n   \n    text-decoration: none;\n    color: black;\n}\n\n.nav-menu.active{\n    position: absolute;\n    left: 13px;\n    \n}\n\n.nav-menu.active + body{\n    overflow-y: hidden;\n}\n\n.nav-menu{\n    display: flex;\n    justify-content: center;\n    flex-direction: column; \n    gap: 10px;\n    padding: 0;\n    text-align: left;\n    position: absolute;\n    -webkit-transition: 0.7s ease-in-out;\n    transition: 0.7s ease-in-out;\n    left: -110vw;\n    top:25px;\n    background: #EDEDED;\n    width: 100%;\n    height: 95vh;\n}\n\n.bar{\n    display: block;\n    width: 25px;\n    height: 3px;\n    margin: 5px 0;\n    background: black;\n}\n\n.ham-menu{\n    display: none;\n}\n\n.hamburger{\n    margin-right: 20px;\n    transition: 0.7s ease-in-out;\n}\n\n.hamburger.active .bar:nth-child(2){\n    opacity: 0;\n}\n\n.hamburger.active .bar:nth-child(1){\n    transform: translatey(8px) rotate(45deg);\n    transition: 0.7s ease-in-out;\n}\n.hamburger.active .bar:nth-child(3){\n    transform: translatey(-8px) rotate(-45deg);\n    transition: 0.7s ease-in-out;\n}\n\n\n\n@media only screen and (max-width: 600px){\n    header{\n        margin: 0;\n        padding: 5px;  \n        position: sticky;\n        top: 0;\n        background-color: #EDEDED;\n        z-index: 2;\n        width: 100%;\n        align-items: center;\n    }\n    .title{\n        padding: 0;\n        margin: 8px;\n    }\n\n    .header-right{\n        display: none;\n    }\n\n    .ham-menu{\n        display: block;\n    }\n    .nav-item{\n        list-style: none;\n        text-decoration: none;\n        font-family: PP-NueBit;\n        font-size: 54px;\n        line-height: 39px;\n        letter-spacing: 0em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
